
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"stroke":"#000","d":"M20.25 1H3.75A2.75 2.75 0 001 3.75v12.375a2.75 2.75 0 002.75 2.75h4.125V22.5a.5.5 0 00.805.395l5.365-4h6.205a2.75 2.75 0 002.75-2.75V3.75A2.75 2.75 0 0020.25 1z"}}),_c('path',{attrs:{"fill":"#FFD250","fill-rule":"nonzero","d":"M7.6 9.85a.628.628 0 01.63-.625h2.825v-2.83a.635.635 0 01.63-.63h.63a.635.635 0 01.63.63v2.83h2.825a.626.626 0 01.63.625v.65a.628.628 0 01-.63.63h-2.825v2.83a.63.63 0 01-.63.625h-.63a.63.63 0 01-.63-.625v-2.85H8.23a.625.625 0 01-.63-.61v-.65z"}})])])
          )
        }
      }
    